import React, {Component} from 'react';
import {connect} from 'react-redux';
import styles from './css/PlanningGuideCta.styl';
import Button from '../../../../../shared/library/FormControls/Button';
import planningThumb from './assets/Planning-Mockup-02.png';
import PlanningGuideLeadForm from '../../../../../shared/PlanningGuideLeadForm';

export class PlanningGuideForm extends Component {
  static propTypes = {
    affiliate: React.PropTypes.object.isRequired,
    funeralHome: React.PropTypes.object.isRequired,
  };

  state = {
    showFields: false,
  };

  toggleFields = () => {
    this.setState({
      showFields: true,
    });
  };

  renderCtaBody() {
    const {showFields} = this.state;

    if (showFields) {
      return <PlanningGuideLeadForm />;
    }

    return (
      <Button handleClick={this.toggleFields} className="FormSubmit">
        Get the Free Guide
      </Button>
    );
  }

  render() {
    return (
      <div className={styles.FuneralGuideForm}>
        <div className={styles.FormHeader}>
          <div className={styles.HeaderContent}>
            <h4 className={styles.FormTitle}>Funeral Planning Guide</h4>
            <p className={styles.FormBody}>Prepare for a meaningful funeral.</p>
          </div>
          <div className={styles.HeaderMedia}>
            <img
              src={planningThumb}
              alt="Funeral Planning Guide"
              className={styles.HeaderImage}
            />
          </div>
        </div>
        {this.renderCtaBody()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  affiliate: state.affiliateStore,
  funeralHome: state.funeralHomeStore,
});

export default connect(mapStateToProps)(PlanningGuideForm);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/PlanningGuideCta/index.js